import React from 'react'
import {
  IconButton,
  TableCell,
  TableRow,
  TableBody,
  TableContainer,
  Table,
  FormControlLabel,
  Switch,
  Container,
  Box,
  CircularProgress,
  Backdrop
} from '@mui/material'
import { PaginationTable } from '../../../UI/Table/TablePagination'
import { TableHeader } from '../../../UI/Table/TableHeader'
import { headCells } from './positionTableConfig'
import { useStyles } from './style'
import { usePosition } from '../../context'
import positionBusiness from '../../actions/positionBusiness'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { PositionGrid } from '../../../../interfaces/Position/Position'
import { Loading, SearchCriteriaPanel } from '../../../UI'

interface PositionTableProps {}

export const PositionTable: React.FC<PositionTableProps> = () => {
  const { state } = usePosition()
  const {
    handleDoubleClick,
    handleOpenDelete,
    handleOpenView,
    handleChangePage,
    handleChangeRowsPerPage,
    handleOnSortChanged
  } = positionBusiness()
  const { rows, page, rowsPerPage, totalItems, sorters, isLoading } = state

  const pagination = {
    page,
    pageSize: rowsPerPage,
    totalItem: totalItems
  }

  const { modifyActiveFieldPosition } = positionBusiness()

  const classes = useStyles()

  if (rows.length === 0)
    return (
      <Container maxWidth='xl'>
        {isLoading ? <Loading /> : <SearchCriteriaPanel elevation={0} />}
      </Container>
    )

  return (
    <Box className={classes.tableContainer}>
      <TableContainer style={{ position: 'relative' }}>
        <Backdrop className={classes.backdrop} open={isLoading}>
          <CircularProgress color='inherit' />
        </Backdrop>
        <Table
          className={classes.table}
          aria-labelledby='tableTitle'
          size={'small'}
          aria-label='enhanced table'
        >
          <TableHeader
            numSelected={0}
            onSelectAllClick={() => console.log()}
            orderInitial='asc'
            orderByInitial='positionName'
            rowCount={rows.length}
            sorters={sorters}
            setSorters={handleOnSortChanged}
            headCells={headCells}
          />

          <TableBody>
            {rows.map((element: PositionGrid) => {
              return (
                <TableRow>
                  <TableCell>
                    {element.warehouse.warehouseName
                      ? element.warehouse.warehouseName
                      : 'Sin Almacén'}
                  </TableCell>
                  <TableCell>{element.positionName}</TableCell>
                  <TableCell>
                    {element.zone.zoneName ? element.zone.zoneName : 'Sin Zona'}
                  </TableCell>
                  <TableCell>
                    {element.subZone.subZoneName
                      ? element.subZone.subZoneName
                      : 'Sin SubZona'}
                  </TableCell>
                  <TableCell>
                    <div
                      style={{
                        marginBottom: '5px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                    >
                      {element.typePosition.typePositionDescription}
                    </div>
                  </TableCell>
                  <TableCell>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={element.active}
                          name={`check${element.id}`}
                          color='primary'
                          onChange={() => modifyActiveFieldPosition(element)}
                          disabled={!element.typePosition.canUpdatePosition}
                        />
                      }
                      label={element.active ? 'Activo' : 'Inactivo'}
                    />
                  </TableCell>
                  <TableCell>
                    <IconButton
                      aria-label='delete'
                      onClick={() => handleOpenDelete(element.id)}
                      disabled={!element.typePosition.canUpdatePosition}
                      title='Eliminar'
                    >
                      <DeleteIcon />
                    </IconButton>

                    <IconButton
                      aria-label='edit'
                      onClick={() => handleDoubleClick(element)}
                      disabled={!element.typePosition.canUpdatePosition}
                      title='Editar'
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      aria-label='view'
                      onClick={() => handleOpenView(element.id)}
                      title='Ver'
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
        <PaginationTable
          pagination={pagination}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Box>
  )
}
